import { Subscription } from 'rxjs/Subscription';
import { BreadcrumbsService } from './../../../../services/cms/breadcrumbs.service';
import { Breadcrumbs } from './../../../../models/cms/breadcrumbs';
//System
import { Component, ChangeDetectionStrategy, ViewEncapsulation, OnInit, ViewContainerRef, Compiler, Inject, Renderer } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { DOCUMENT } from '@angular/platform-browser';
import { DomAdapter, getDOM } from '@angular/platform-browser/src/dom/dom_adapter';

//Services
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { CmsContentService } from "./../../../../services/cms/cms-content.service";
import { LanguageService } from "./../../../../services/cms/language.service";
import { SeoService } from "./../../../../services/core/seo.service";
import { ScriptService } from "./../../../../services/cms/script.service";
import { HelperService } from "./../../../../services/core/helper.service";
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";

//Models
import { CmsPage } from "./../../../../models/cms/cms-page";
import { SeoViewModel } from "./../../../../models/core/seo";
import { Menu } from '../../../../models/cms/menu';
import { CmsMenuListService } from '../../../../services/cms/cms-menu-list.service';
import { RoutesService } from '../../../../services/core/routes.service';

@Component({
    template: "",
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated
})

export class CmsPageComponent implements OnInit {
    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private cmsContentService: CmsContentService,
            private route: ActivatedRoute,
            private languageService: LanguageService,
            private router: Router,
            private cmsComponentService: CmsComponentService,
            @Inject('isBrowser') private isBrowser: boolean,
            private seo: SeoService,
            private renderer: Renderer,
            @Inject(DOCUMENT) private document: any,
            private scriptService: ScriptService
        ) { this.router.routeReuseStrategy.shouldReuseRoute = () => false; }

    subManager = new Subscription();

    ngOnInit() {
        //Reading Language information
        let longLangCode: string = this.languageService.getLongLang();
        let shortLangCode: string = this.languageService.getShortLang();

        let subParams = this.route.params.subscribe(params => {
            let id = params['id'];
            let header: any;
            let headDataSub = this.cmsComponentService.getHeaderData().subscribe(result => {
                header = result;
                let SideMenuData = this.cmsComponentService.getSideMenuData().subscribe(result1 => {
                    if (result1.Categories) {
                        header.Categories = result1.Categories;
    
                    }
                });
                this.subManager.add(SideMenuData);
            });
            this.subManager.add(headDataSub);
            //Reading id from url
            //If id is set, then the page is retrived by id, else by url
            if (id !== undefined) {
                let pageId = '' + id;

                let cmsIdSub = this.cmsContentService.getCmsPageById(longLangCode, pageId).subscribe(result => {
                    if (result.SeoInformation) {
                        result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                        result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
                    }

                    if (this.isBrowser) {
                        this.onGetPageSuccess(result, header);
                    }
                    else {
                        //-- Get head and body scripts
                        this.scriptService.setupExternalScripts(result, this.scriptService.typeCmsPage, pageId);

                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation, result.TopImage)
                        this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
                    }
                });

                this.subManager.add(cmsIdSub);
            }

            else {
                let url = this.router.url;

                let cmsUrlSub = this.cmsContentService.getCmsPageByUrl(longLangCode, url).subscribe(result => {
                    if (this.isBrowser) {
                        this.onGetPageSuccess(result, header);
                    }
                    else {
                        //-- Get head and body scripts
                        this.scriptService.setupExternalScripts(result, this.scriptService.typeCmsPage, result.IdLevel);

                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation, result.TopImage)
                        this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
                    }
                });

                this.subManager.add(cmsUrlSub);
            }
        });

        this.subManager.add(subParams);
    }

    ngOnDestroy() {
        this.subManager.unsubscribe();
    }

    onGetPageSuccess(cmsResult: CmsPage, header: any) {
        //Creating subcomponent whith the object get from server
        let subComponent = this.createSubComponent(cmsResult, header);

        //injecting created component
        this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
    }

    //Creates component to inject 
    private createSubComponent(cmsPageObj: CmsPage, header: any) {
        @Component({
            template: cmsPageObj.TemplateHtml
        })

        class ChildComponent implements OnInit {
            private _dom: DomAdapter = getDOM();
            constructor
                (
                    private seoService: SeoService,
                    @Inject(DOCUMENT) private document: any,
                    @Inject('isBrowser') private isBrowser: boolean,
                    private _elementRef: ViewContainerRef,
                    private scriptService: ScriptService,
                    private helperService: HelperService,
                    private cmsMenuListService: CmsMenuListService,
                    private languageService: LanguageService,
                    private routesService: RoutesService,
                    private breadcrumbsService: BreadcrumbsService
                ) { }

            cmspage: CmsPage = cmsPageObj;
            private seoInfo: SeoViewModel = cmsPageObj.SeoInformation;
            private pageIsInit: boolean = false;
            menuItems: Menu[] = [];
            headerData: any = header;
            footerData: any = cmsPageObj.footerData;

            private lang: string = this.languageService.getLongLang();
            private breadcrumbs: Breadcrumbs[] = [];
            //private breadcrumbs: Breadcrumbs[] = cmsPageObj.BreadcrumbsInfo;
            subManager = new Subscription();

            ngOnInit() {
                let paramPage = "cmspage";

                //setting new breadcrumbs, setTimeout must be called because it is initializating new event, in opposite, app is crashed
                this.breadcrumbs = cmsPageObj.BreadcrumbsInfo;
                setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);

                if (this.isBrowser == true) {
                    setTimeout(x => this.menuItems = cmsPageObj.menuItems, 1);
                    //     let cmsMenuSub = this.cmsMenuListService.LoadData(this.cmspage.IdLevel, this.lang).subscribe(result => {
                    //         if (result != null) {
                    //             this.menuItems = result;
                    //         }
                    //     });

                    //     this.subManager.add(cmsMenuSub);
                }
            }

            imageTitle(imgPath) {
                let imgName = this.helperService.GetFileNameFromPath(imgPath);
                return imgName;
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);

                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();

                this.pageIsInit = true;
            }

            ngOnDestroy() {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            }
        }

        return ChildComponent;
    }
}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/cms/page/sys/cms-page.component.ts